import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
var GTM_INIT = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM_CONTAINER_ID');"; // This lives outside of the component so it can be used in places that are
// not in the component heirarchy (such as sagas).

export var trackGoogleTagManagerEvent = function trackGoogleTagManagerEvent(data) {
  /* istanbul ignore next */
  if (__CLIENT__ || __TEST__) {
    if (readLocalStorage('trackingDebug')) {
      console.info('Tracking GTM', data); // eslint-disable-line no-console
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    var loc = document.location;
    window.dataLayer.push({
      originalLocation: "".concat(loc.protocol, "//").concat(loc.hostname).concat(loc.pathname).concat(loc.search)
    });
  }
};
export var GoogleTagManager =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GoogleTagManager, _React$Component);

  function GoogleTagManager() {
    _classCallCheck(this, GoogleTagManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoogleTagManager).apply(this, arguments));
  }

  _createClass(GoogleTagManager, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var userId = this.props.userId;

      if (!prevProps.userId && userId) {
        trackGoogleTagManagerEvent({
          userId: String(userId)
        });
      }
    }
  }, {
    key: "createTagEventProperties",
    value: function createTagEventProperties() {
      var _this$props = this.props,
          glsLocationId = _this$props.glsLocationId,
          userId = _this$props.userId;
      var properties = {
        glsLocationId: glsLocationId,
        userId: userId
      };
      var filteredProperties = Object.keys(properties).reduce(function (result, key) {
        if (properties[key] !== undefined) {
          result[key] = String(properties[key]);
        }

        return result;
      }, {});
      return filteredProperties;
    }
  }, {
    key: "render",
    value: function render() {
      var containerId = this.props.containerId;
      var eventProperties = this.createTagEventProperties();

      if (Object.keys(eventProperties).length > 0) {
        trackGoogleTagManagerEvent(eventProperties);
      }

      var code = GTM_INIT.replace(/GTM_CONTAINER_ID/, containerId);
      return React.createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: code
        }
      });
    }
  }]);

  return GoogleTagManager;
}(React.Component);
GoogleTagManager.propTypes = {
  containerId: PropTypes.string.isRequired,
  userId: PropTypes.number,
  glsLocationId: PropTypes.number
};